
export function InitPopovers() {
    $('[data-toggle="popover"]').popover({
        html: true,
        container: 'body',
        content: function () {
            let content = $(this).data("content");

            if (content == undefined) {
                let htmlContentSelector = $(this).data("content-html");
                content = $(htmlContentSelector).html();
            }

            return content;
        }
    });
}

jQuery(() => {
    InitPopovers();
});
